import classes from "./ScrollTop.module.css";

function ScrollTop() {
  const ScrollTopSVG = () => {
    return (
      <div className={classes.scrolltop} onClick={ScrollUpTop}>
        <div className={classes.scrolltopbubble}>
          <svg
            width="99"
            height="170"
            viewBox="0 0 99 170"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M60.69 3.64006C42.47 0.780058 22.24 8.51006 11.68 22.2901C1.13001 36.0601 1.55001 56.3701 13.79 68.9501C16.84 72.0901 20.58 74.7501 24.9 76.2201C29.13 77.6501 33.73 77.8701 38.24 77.8501C50.63 77.8001 63.3 75.9401 74.07 70.3801C84.84 64.8201 93.48 55.1401 94.99 43.9801C95.75 38.3601 94.7 32.6101 92.57 27.2901C87.84 15.4501 74.22 6.43006 60.69 3.64006Z" />
          </svg>
        </div>

        <div>
          <svg
            className={classes.scrolltoparrow}
            width="99"
            height="170"
            viewBox="0 0 99 170"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M70.44 58.02C60.63 46.51 54.3 33.54 49.92 15.98L49.34 13.64L44.25 14.73L44.2 16.7C43.93 30.82 38.73 45.24 28.28 60.75L32.43 63.54C38.75 54.15 43.25 45.1 45.99 36.24C49.3 78.4 44.6 121.68 32.24 162.04L37.02 163.5C49.6 122.4 54.37 78.32 50.94 35.39C54.95 45.17 60.04 53.51 66.63 61.25L70.44 58.02Z"
              fill="#141413"
            />
          </svg>
        </div>
      </div>
    );
  };

  function ScrollUpTop() {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  }

  return <ScrollTopSVG />;
}

export default ScrollTop;
